import { render, staticRenderFns } from "./addQuotaForNode.vue?vue&type=template&id=a0614f2a&scoped=true&"
import script from "./addQuotaForNode.vue?vue&type=script&lang=js&"
export * from "./addQuotaForNode.vue?vue&type=script&lang=js&"
import style0 from "./addQuotaForNode.vue?vue&type=style&index=0&id=a0614f2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0614f2a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a0614f2a')) {
      api.createRecord('a0614f2a', component.options)
    } else {
      api.reload('a0614f2a', component.options)
    }
    module.hot.accept("./addQuotaForNode.vue?vue&type=template&id=a0614f2a&scoped=true&", function () {
      api.rerender('a0614f2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/pages/wallet/fullNode/addQuotaForNode.vue"
export default component.exports